module.exports = kolibriGlobal.coreVue.components.KPageContainer;